//import FilepondPluginImageCrop from 'filepond-plugin-image-crop';
import FilepondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilepondPluginImageValidateSize from 'filepond-plugin-image-validate-size';
import 'filepond-polyfill/dist/filepond-polyfill.esm';
import * as FilePond from 'filepond';
import ClassLogger from 'ClassLogger';
import Gallery from './_gallery.js';

class uploadImages {
    constructor() {
        let self = this;
        self.logger = ClassLogger(self, true);
        self.baseUrl = window.siteconfig.api_baseurl;
    }

    init($mediauploads) {
        let self = this;

        $mediauploads.each(function (i, component) {

            let $component = $(component);

            let options = $(component).data('mediaupload');
            self.logger.log('Initializing a mediaupload element', options);

            let type = options.type; // for example avatar
            let area = options.area; // for example profile

            let targetid = options.targetid;
            if (area === 'profiles' && (targetid === undefined || targetid === '')) {
                targetid = ':ME:';
            }

            let thumb = type;
            if (options.thumb) {
                thumb = options.thumb;
            }

            let multiple = false;

            if (options.multiple) {
                multiple = options.multiple;
            }



            let url = area + '/' + targetid + '/media/' + type;

            self.logger.log("Initialized upload field: " + url);

            if ($component.data('pondElem')) {
                self.logger.log('found existing pondElem – destroying');
                $component.data('pondElem').destroy();
            }

            FilePond.registerPlugin(FilepondPluginFileValidateType, FilepondPluginImageValidateSize);

            setTimeout(function () {

                let pondElem = FilePond.create($component.find('input[type="file"]')[0], {
                    maxFiles: multiple ? 8 : 1,
                    maxParallelUploads: 2,
                    allowMultiple: multiple ? true : false,
                    allowReplace: multiple ? false : true,
                    allowFileTypeValidation: true,
                    allowFileSizeValidation: true,
                    checkValidity: true,
                    allowRevert: false,
                    maxFileSize: '2MB',
                    acceptedFileTypes: ['image/jpeg', 'image/png'],
                    name: 'file',
                    server: {
                        url: self.baseUrl,
                        process: {
                            url: url,
                            method: 'POST',
                            ondata: function (response) {
                                if (multiple) {
                                    let uniquename = $component.data('mediaupload-uniquename');
                                    let $gallery = $('[data-gallery-uniquename="' + uniquename + '"]');
                                    new Gallery().preloader($gallery, 'show');
                                }
                                return response;
                            },
                            onload: function (response) {
                                if (response === '{}') {
                                    alert('Fehler beim Upload!');
                                    return;
                                }
                                let data = JSON.parse(response).data;
                                if (multiple === false) {
                                    self.insertImage(data.thumbs[thumb].url, options.type, targetid);
                                } else {
                                    // find matching gallery
                                    let uniquename = $component.data('mediaupload-uniquename');
                                    let $gallery = $('[data-gallery-uniquename="' + uniquename + '"]');
                                    let $gallerylist = $gallery.find('.gallery');
                                    let companyUrl = 'companies/' + targetid + '/gallery';
                                    let thisGallery = new Gallery();
                                    thisGallery.addImage('edit', data, $gallerylist, uniquename);
                                    thisGallery.preloader($gallery, 'hide');
                                    thisGallery.deleteImage($gallery, companyUrl, uniquename);
                                }

                                return response;
                            },
                            onerror: function (response) {
                                if (multiple) {
                                    let uniquename = $component.data('mediaupload-uniquename');
                                    let $gallery = $('[data-gallery-uniquename="' + uniquename + '"]');
                                    new Gallery().preloader($gallery, 'hide');
                                }
                                return response.data;
                            }
                        }

                    },

                    allowImageValidateSize: true,
                    imageValidateSizeMinWidth: 300,
                    imageValidateSizeMinHeight: 300,
                    imageValidateSizeMaxWidth: 4000,
                    imageValidateSizeMaxHeight: 4000,
                    labelIdle: '<span class="filepond--label-text">Bild hier ablegen oder <span class="filepond--label-action">Datei suchen</span></span>',
                    labelFileWaitingForSize: 'Warten auf Dateigröße',
                    labelFileSizeNotAvailable: 'Dateigröße nicht verfügbar',
                    labelFileCountSingular: 'Datei in Liste',
                    labelFileCountPlural: 'Dateien in Liste',
                    labelFileLoading: 'Laden',
                    labelFileAdded: 'Hinzugefügt',
                    labelFileRemoved: 'Entfernt',
                    labelFileLoadError: 'Fehler beim laden',
                    labelFileProcessing: 'Bild wird hochgeladen… Bitte warten!',
                    labelFileProcessingComplete: 'Upload abgeschlossen',
                    labelFileProcessingAborted: 'Upload abgebrochen',
                    labelFileProcessingError: 'Fehler beim Upload',
                    labelTapToCancel: 'Abbrechen',
                    labelTapToRetry: 'Wiederholen',
                    labelTapToUndo: 'Rückgängig',
                    labelButtonRemoveItem: 'Entfernen',
                    labelButtonAbortItemLoad: 'Abbrechen',
                    labelButtonRetryItemLoad: 'Wiederholen',
                    labelButtonAbortItemProcessing: 'Abbrechen',
                    labelButtonUndoItemProcessing: 'Rückgängig',
                    labelButtonRetryItemProcessing: 'Wiederholen',
                    labelButtonProcessItem: 'Hochladen',
                    labelMaxFileSizeExceeded: 'Dateigröße nicht verfügbar',
                    labelMaxTotalFileSizeExceeded: 'Maximum Dateigröße erreicht',
                    imageValidateSizeLabelImageSizeTooBig: 'Das Bild ist zu groß',
                    imageValidateSizeLabelFormatError: 'Bildtyp nicht unterstützt'
                });

                $component.data('pondElem', pondElem);
                pondElem.removeFiles();

            }, 100);

        });
    }

    insertImage(src, type, targetId) {
        let self = this;
        self.logger.log("Inserting thumbnail " + type);
        if ($('[data-mediatarget="' + type + '-' + targetId + '"]').length) {
            $('[data-mediatarget="' + type + '-' + targetId + '"]').attr('src', src);
        } else {
            $('#' + type).attr('src', src);
        }
    }
}

export default uploadImages;
